import React from "react";
import { Redirect } from "react-router-dom";

// 1. Login
import LoginNew from "../pages/Authentication/LoginNew";
import Logout from "../pages/Authentication/Logout";

// 2. Pages
import DashboardNew from "../pages/DashboardNew";
import Settings from "../pages/Settings/Settings";
import Configurations from "../pages/Settings/Configurations";
import MemberLoggedProfile from "../pages/Profile";
import PagesComingsoon from "../pages/Settings/PagesComingsoon";

// 3. Election modules
import ObserverModule from "../pages/Election/Observer";
import PatronagerModule from "../pages/Election/Patronager";
import PatronageReferred from "../pages/Election/Patronage/PatronageReferred";
import Emigrants from "../pages/Election/Patronage/Emigrants";
import MyPatronagers from "../pages/Election/Patronage/MyPatronagers";
import MyDiasporaReferences from "../pages/Diaspora/MyDiasporaReferences";
import MyVHPVoters from "../pages/VHP";

// 4. News & Notifications
import MemberNews from "../pages/News";
import MemberNotifications from "../pages/Notifications";

// 5. Tasks
import TaskList from "../pages/TasksNew/TaskList";
import TaskDetail from "../pages/TasksNew/TaskDetail";
import QRScanner from "../pages/TasksNew/QRScanner";


const authProtectedRoutes = [
	// 1. Dashboard
	{ path: "/dashboard", component: DashboardNew },

	// 2. Settings & Profile
	{ path: "/profile", component: MemberLoggedProfile },
	{ path: "/settings", component: Settings },
	{ path: "/configurations", component: Configurations },

	// 3. Tasks (new module)
	{ path: "/tasks/qr", exact: true, component: QRScanner },
	{ path: "/tasks/:id", exact: true, component: TaskDetail },
	{ path: "/tasks", exact: true, component: TaskList },

	// Keep old routes as redirects for backwards compatibility
	{ path: "/tasks-received", component: () => <Redirect to="/tasks" /> },
	{ path: "/task-qr-list", component: () => <Redirect to="/tasks/qr" /> },

	// 4. Observer & Patronager
	{ path: "/observer-module", component: ObserverModule },
	{ path: "/patronager-module", component: PatronagerModule },

	// 5. Patronage
	{ path: "/patronage-referred", component: PatronageReferred },
	{ path: "/emigrant", component: Emigrants },
	{ path: "/diaspora-references", component: MyDiasporaReferences },
	{ path: "/my-vhp-voters", component: MyVHPVoters },
	{ path: "/my-patronage", component: MyPatronagers },

	// 6. News
	{ path: "/news-grid", component: MemberNews },

	// 7. Notifications
	{ path: "/notifications", component: MemberNotifications },

	// 8. Bonus Page
	{ path: "/pages-comingsoon", component: PagesComingsoon },

	// 9. Home Root
	{ path: "/", exact: true, component: () => <Redirect to="/dashboard" /> }
];


const publicRoutes = [
	{ path: "/logout", component: Logout },
	{ path: "/login", component: LoginNew },
];


export { authProtectedRoutes, publicRoutes };
